<template>
	<div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
		<h1 class="fw-bold">404 </h1>
		<p>Leider wurde da etwas nicht gefunden 8-( </p>
	</div>
</template>

<script>
export default {};
</script>
